import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
import { CssBaseline } from "@mui/material";
import { DevSupport } from "@react-buddy/ide-toolbox";
import { ComponentPreviews, useInitial } from "./dev";
import { queryClient } from "./services/queries";
import { store } from "./redux/Store";
import { Provider as StateProvider } from "react-redux";
import { BrowserRouter } from "react-router-dom";
import { QueryClientProvider } from "react-query";
ReactDOM.render(
  <React.StrictMode>
    <CssBaseline />
    <DevSupport ComponentPreviews={ComponentPreviews}
                useInitialHook={useInitial}
    >
      <QueryClientProvider client={queryClient}>
        <StateProvider store={store}>
          <BrowserRouter>
            <App />
          </BrowserRouter>
        </StateProvider>
      </QueryClientProvider>
    </DevSupport>
  </React.StrictMode>,
  document.getElementById("root"),
);